import {
  ButtonV2,
  LabraToolTipV2,
  NoteV2,
  TextAreaWithChips,
} from '@labrav/react-components'
import { useStyles } from './NotificationEmailChipInput.styles'
import clsx from 'clsx'
import { isEmpty } from 'lodash'
import { NotificationRecipients } from '../../../types/addEditProduct'

export interface NotificationEmailChipInputProps {
  notificationRecipients: NotificationRecipients
  handleTextAreaChange: (newTags: string, key: string) => void
  handleDelete: (value: string, key: string) => void
  getIfError: (key: string) => boolean
  getErrorText: (key: string) => string
  configureEmailsInAllInputs?: () => void
  focusedField?: string | null
  disabledConfigure?: boolean
  setFocusedField: (field: string | null) => void
  isFormLocked?: boolean
  detailView?: boolean
  handleBlur: {
    (e: React.FocusEvent<any, Element>): void
    <T = any>(fieldOrEvent: T): T extends string ? (e: any) => void : void
  }
  textAreaMappings: {
    [key: string]: {
      title: string
      description?: string
      note?: string
    }
  }
  detailViewTooltip?: string
  productView?: boolean
}

export const NotificationEmailChipInput = ({
  notificationRecipients,
  handleTextAreaChange,
  handleDelete,
  getIfError,
  getErrorText,
  configureEmailsInAllInputs,
  focusedField,
  disabledConfigure,
  setFocusedField,
  isFormLocked,
  detailView,
  handleBlur,
  textAreaMappings,
  detailViewTooltip,
}: NotificationEmailChipInputProps) => {
  const { classes } = useStyles()

  const isDisabled = isFormLocked || detailView
  return Object.keys(textAreaMappings).map(keyName => {
    const isDescription = !isEmpty(textAreaMappings[keyName]?.description)
    const isNote = !isEmpty(textAreaMappings[keyName]?.note)
    return (
      <>
        <div className={classes.rootContainer}>
          <div className={classes.label}>
            {' '}
            {textAreaMappings[keyName].title}
          </div>
          {isDescription && (
            <div
              className={clsx(
                classes.description,
                isNote ? classes.noteSpacing : ''
              )}
            >
              {textAreaMappings[keyName].description}
            </div>
          )}
          {isNote && (
            <div className={classes.description}>
              <NoteV2 description={textAreaMappings[keyName]?.note} />
            </div>
          )}
          <LabraToolTipV2
            followCursor={detailView}
            tooltipPlacement="bottom-start"
            description={detailViewTooltip}
            className={classes.fullWidth}
          >
            <div className={classes.textAreaWithChip}>
              <TextAreaWithChips
                id={`notificationRecipients.${keyName}`}
                label="Add emails by pressing 'enter' or adding a comma in between"
                selectedValues={
                  notificationRecipients?.[
                    keyName as keyof NotificationRecipients
                  ]
                }
                onChange={(value: string) =>
                  handleTextAreaChange(value, keyName)
                }
                handleDelete={(value: string) => handleDelete(value, keyName)}
                error={getIfError(keyName)}
                helperText={getErrorText(keyName)}
                onBlur={handleBlur}
                onFocus={() => setFocusedField(keyName)}
                disabled={isDisabled}
                viewOnly={detailView}
              />
              {focusedField === keyName && (
                <div className={classes.button}>
                  <ButtonV2
                    styleType="link"
                    onClick={configureEmailsInAllInputs}
                    smallVariant
                    disabled={disabledConfigure || isDisabled}
                    data-testid={'configure-all'}
                  >
                    Configure these emails to all the fields
                  </ButtonV2>
                </div>
              )}
            </div>
          </LabraToolTipV2>
        </div>
      </>
    )
  })
}
